module.exports = __webpack_public_path__ + "static/media/04.13878e99.jpg";